module.exports = __webpack_public_path__ + "static/img/pxBanner.26c582e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/pxBanner.png
// module id = gkXM
// module chunks = 2